var defaultTemplates = {
    labelText: function labelText(param) {
        var name = param.name;
        return name;
    }
};

export { defaultTemplates as default };
